import { useStats } from '../../context/StatsContext';
import { motion } from 'framer-motion';
import founderImg from '../../assets/founder.webp';
export default function OurStorySection(){
  const { state: stats } = useStats();
    
    return(
        <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-14 pb-4 sm:pb-6">
        <div className="grid lg:grid-cols-[1.05fr_0.95fr] gap-14 lg:gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="relative order-2 lg:order-1"
          >
            <div className="absolute -inset-5 rounded-[2rem] bg-[radial-gradient(circle_at_top_left,rgba(28,143,134,0.14),transparent_48%),radial-gradient(circle_at_bottom_right,rgba(23,111,104,0.10),transparent_42%)] blur-2xl" />
            <div className="relative overflow-hidden rounded-[2rem] shadow-[0_28px_60px_-32px_rgba(21,48,43,0.4)]">
              <img 
                src={founderImg} 
                alt="Founder Meenakshi Paliwal practicing yoga"
                className="h-[520px] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/14 via-transparent to-transparent" />
            </div>
          </motion.div>
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="order-1 lg:order-2"
          >
            <p className="text-xs sm:text-sm font-semibold tracking-[0.28em] uppercase text-[#1C8F86] mb-4">
              Our Story
            </p>
            <h2 className="text-4xl sm:text-5xl font-semibold text-[#15302B] leading-tight tracking-[-0.03em] mb-6">
              MetaFit is India&apos;s wellness unity story
            </h2>
            <div className="space-y-5 text-lg text-[#4D625D] leading-8">
              <p>
                Founded by Meenakshi Paliwal, MetaFit Wellness brings together top Indian yoga teachers
                with a shared vision: making ancient wisdom feel modern, accessible, and deeply human.
              </p>
              <p>
                With 14 years of experience and 5,000+ lives touched, the platform was built in 2023 to
                bridge tradition and innovation through AI-personalized classes, live sessions, and mindful guidance.
              </p>
              <p className="border-l-4 border-[#1C8F86] pl-5 py-1 italic font-semibold text-[#15302B]">
                MetaFit is more than an app; it&apos;s a calm, connected path for people who want wellness with substance.
              </p>
            </div>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.4 }}
                className="rounded-xl border border-[#E0D4B8]/60 bg-white/40 p-4 shadow-[0_4px_20px_rgb(0,0,0,0.03)] backdrop-blur-sm transition-all hover:bg-white/60"
              >
                <h3 className="text-[10px] uppercase font-semibold tracking-[0.15em] text-[#6A7A75] mb-1">Founded</h3>
                <p className="text-xl font-bold text-[#1C8F86]">2023</p>
              </motion.div>
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.5 }}
                className="rounded-xl border border-[#E0D4B8]/60 bg-white/40 p-4 shadow-[0_4px_20px_rgb(0,0,0,0.03)] backdrop-blur-sm transition-all hover:bg-white/60"
              >
                <h3 className="text-[10px] uppercase font-semibold tracking-[0.15em] text-[#6A7A75] mb-1">Teachers</h3>
                {stats.loading ? (
                  <div className="h-6 w-12 animate-pulse rounded bg-[#E8EFEA]" />
                ) : (
                  <p className="text-xl font-bold text-[#1C8F86]">{stats.totalInstructors}+</p>
                )}
              </motion.div>
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.6 }}
                className="rounded-xl border border-[#E0D4B8]/60 bg-white/40 p-4 shadow-[0_4px_20px_rgb(0,0,0,0.03)] backdrop-blur-sm transition-all hover:bg-white/60"
              >
                <h3 className="text-[10px] uppercase font-semibold tracking-[0.15em] text-[#6A7A75] mb-1">Users</h3>
                {stats.loading ? (
                  <div className="h-6 w-12 animate-pulse rounded bg-[#E8EFEA]" />
                ) : (
                  <p className="text-xl font-bold text-[#1C8F86]">{stats.totalStudents}+</p>
                )}
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
      </div>

    )
}
